
import React from 'react';
import Layout from '@/components/Layout/Layout';
import AngleConverter from '@/components/UnitConverter/AngleConverter';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const AngleConverterPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/converters" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Converters
          </Link>
          <h1 className="text-3xl font-bold mb-2">Angle Converter</h1>
          <p className="text-gray-600 mb-6">
            Convert between different units of angular measurement, from degrees to radians and more.
          </p>
        </div>
        
        <div className="mb-8">
          <AngleConverter />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Angle Converter</h2>
          <p>
            Our angle converter tool helps you convert between different angular measurement units 
            used in mathematics, engineering, navigation, and many other fields. An angle measures the 
            amount of rotation between two intersecting lines or planes.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Common Angle Unit Conversions</h3>
          <p>
            Some of the most frequently used angle conversions include:
          </p>
          <ul className="list-disc ml-6">
            <li>Converting between degrees and radians (mathematics and physics)</li>
            <li>Converting between degrees and gradians (engineering and surveying)</li>
            <li>Converting between degrees and minutes/seconds (navigation and astronomy)</li>
            <li>Converting between complete turns and other units (mechanics and electronics)</li>
          </ul>
          
          <h3 className="text-lg font-medium mt-6 mb-2">How to Use the Angle Converter</h3>
          <p>
            Using our angle converter is simple:
          </p>
          <ol className="list-decimal ml-6">
            <li>Enter the value you want to convert in the "From" field</li>
            <li>Select the angle unit you're converting from</li>
            <li>Select the angle unit you want to convert to</li>
            <li>The converted value will appear automatically</li>
          </ol>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Common Angle References</h3>
          <p>
            Here are some common angle references:
          </p>
          <ul className="list-disc ml-6">
            <li>A full circle is 360 degrees or 2π radians</li>
            <li>A straight angle is 180 degrees or π radians</li>
            <li>A right angle is 90 degrees or π/2 radians</li>
            <li>An acute angle is less than 90 degrees</li>
            <li>An obtuse angle is between 90 and 180 degrees</li>
          </ul>
          
          <p className="mt-6">
            The angle converter supports a comprehensive range of units, including degrees, radians, 
            gradians, minutes, seconds, turns, and more. Whether you're working on mathematical problems, 
            engineering designs, navigation calculations, or astronomy observations, 
            our converter provides accurate conversions between all common angular units.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default AngleConverterPage;
